import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import styled from 'styled-components'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import * as routes from 'core/routing/constants'
import wizardsShape from 'core/components/wizard/shapes'
import { List, Row, Col } from 'core/components/ui'
import RenderRow from 'core/layouts/render-row'
//import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font, greys } from 'assets/themes/theme-default'
import PriceFrom, { SIZE as PriceFromSIZE } from 'core/layouts/price-from'
import { configuratorShape, motorShape } from '../../shapes'

const StyledListItem = styled(List.Item)`
  padding: 0;
  margin-right: 10px;
`

const DetailsWrapper = styled.div`
  padding: 10px 20px;
  margin: 10px 0 0 0;
`

const StyledRow = styled(Row)`
  margin: 0 0 0px 0;
  min-height: 80px;
  padding: 10px 0;
  line-height: normal;
  color: ${props => (props.selected ? greys.light4 : greys.dark1)};
  font-weight: ${font.weight.bold};
  box-shadow: ${props => props.selected && `0 2px 15px rgba(0,0,0,0.4)`};
  background: ${props => (props.selected ? props.theme.colors.color1.bg : greys.light4)};
  svg {
    fill: ${props => (props.selected ? greys.light4 : greys.dark1)};
  }
  ${DetailsWrapper} {
    border-top: 1px solid ${props => (props.selected ? greys.light4 : props.theme.colors.color1.bg)};
  }
`

const ListItem = props => {
  const { setWizards, wizards, history, configurator, setConfigurator, item, intl } = props

  const { motor } = configurator

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_MOTORS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)

    history.push(extendedStep.hash)
  }

  const desactivateNextSteps = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const currentIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_MOTORS)

    const steps = aStepsActive.map((step, index) => {
      let returnedStep = step
      if (index > currentIndex) returnedStep = { ...step, isActive: false }

      return returnedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: steps }

    setWizards(extentedWizards)
  }

  const handleOnChangeSelection = async () => {
    // Design
    const design = _.isEqual(item, configurator.motor)
      ? configurator.design
      : {
          exterior: {
            type: null,
            color: null
          },
          interior: null
        }

    const designList = _.isEqual(item, configurator.motor)
      ? configurator.designList
      : {
          exterior: {
            type: [],
            color: []
          },
          interior: { leathers: [], fabrics: [] }
        }

    // Options
    const options = _.isEqual(item, configurator.motor) ? configurator.options : null

    const optionsList = _.isEqual(item, configurator.motor)
      ? configurator.optionsList
      : { equipmentGroups: [], equipments: [] }

    const funding = _.isEqual(item, configurator.motor) ? configurator.funding : null

    const fundingList = _.isEqual(item, configurator.motor) ? configurator.fundingList : null

    if (!_.isEqual(item, configurator.motor)) await desactivateNextSteps()

    setConfigurator({
      ...configurator,
      motor: item,
      price: item.price,
      designList,
      design,
      optionsList,
      options,
      funding,
      fundingList
    })
    activateNextStep()
  }
  //const getCardAction = () => <PriceFrom value={item.price} />
  //

  const renderRow = (value, icon) => <RenderRow value={value} icon={icon} />

  return (
    <StyledListItem
      onClick={e => {
        e.preventDefault()
        handleOnChangeSelection()
      }}
    >
      <StyledRow
        type="flex"
        align="middle"
        gutter={50}
        selected={!motor ? false : item.title === motor.title}
      >
        <Col span={14}>{item.title}</Col>

        <Col span={10}>
          <PriceFrom value={item.price} size={PriceFromSIZE.sm} />
        </Col>

        <Col span={24}>
          <DetailsWrapper>
            <Row>
              {item.energy && <Col span={12}>{renderRow(item.energy, svg.gas_pump)}</Col>}
              {item.gearBox && <Col span={12}>{renderRow(item.gearBox, svg.reports)}</Col>}
              {item.doors && (
                <Col span={12}>{renderRow(`${intl.formatNumber(item.doors)}`, svg.doors)}</Col>
              )}
              {item.power && (
                <Col span={12}>
                  {renderRow(`${intl.formatNumber(item.power)} Ch/DIN`, svg.power)}
                </Col>
              )}
              {item.consumption && (
                <Col span={12}>
                  {renderRow(`${intl.formatNumber(item.consumption)} l/100km`, svg.consumption)}
                </Col>
              )}
              {item.co2 && (
                <Col span={12}>{renderRow(`${intl.formatNumber(item.co2)} g/km`, svg.cloud_2)}</Col>
              )}
            </Row>
          </DetailsWrapper>
        </Col>
      </StyledRow>
    </StyledListItem>
  )
}

ListItem.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired,
  item: motorShape.isRequired
}

export default withRouter(injectIntl(ListItem))
